import { DiscountBanner, DiscountsActions, discountsTypes, DiscountsValue } from './types'

const actions = {
  fetchDiscountBanner: (
    callback?: (succ: boolean) => void
  ): DiscountsActions => ({
    type: discountsTypes.FETCH_DISCOUNT_BANNER,
    payload: null,
    callback
  }),
  setValue: (payload: DiscountsValue): DiscountsActions => ({
    type: discountsTypes.SET_VALUE,
    payload
  }),
  createDiscountBanner: (
    payload: Partial<DiscountBanner>,
    callback?: (succ: boolean) => void
  ): DiscountsActions => ({
    type: discountsTypes.CREATE_DISCOUNT_BANNER,
    payload,
    callback
  }),
}

export default actions
